import axios from 'axios';
import { axiosInstance } from './config';
import {
  IRegisterRefundInfoPayload,
  IGetMedicalRefundListResponse,
  IExcelBody,
  IExcelResponse,
  IUploadExcelImagePayload,
  IMedicalPassportValidateRespones,
  ISendVerificationMailPayload,
  IVerifyEmailPayload,
  IGetVerifiedEmailPayload,
  IRegisterRefundInfoResponse,
  IUpdateKorDeparture,
  VerifyAccountPayload,
  VerifyAccountResponse,
  AirportListPayload,
  AirportListResponse,
  OpenObserveRequest,
  CheckEmailPayload,
  ISendReceiptEmailPayload,
} from '@/types/common.type';
import { getFormattedTableData } from '@/utils/format.util';
import {
  ICheckKorDepartureRespones,
  IMedicalDepartureInfoPayload,
  IMedicalHomePayload,
  IMedicalHomeResponse,
  IMyQna,
} from '@/types/medical.type';

// const axiosInstance = axios.create(axiosRequestConfiguration);

const ADMIN_SERVER =
  // @ts-ignore
  import.meta.env.MODE === 'development'
    ? 'https://medical-admin-test.ktaxpay.com'
    : 'https://medical.successmode.co.kr';

const ERP_SERVER = 'https://erp.successmode.co.kr';

const getAxios = async <ResponseType, ParamType>(
  url: string,
  queryParams?: ParamType,
  config?: any,
) =>
  axiosInstance.get<ResponseType>(url, {
    ...(queryParams && { params: queryParams }),
    ...config,
  });
const postAxios = async <ReturnType, BodyType, ParamType>(
  url: string,
  body: BodyType,
  queryParams?: ParamType,
  headers?: Record<string, string>,
) =>
  axiosInstance.post<ReturnType>(url, body, {
    ...(queryParams && { params: queryParams }),
    ...(headers && { headers: headers }),
  });
const patchAxios = async <ResponseType, BodyType, ParamType>(
  url: string,
  body?: BodyType,
  queryParams?: ParamType,
) =>
  axiosInstance.patch<ResponseType>(url, body, {
    ...(queryParams && { params: queryParams }),
  });
const putAxios = async <ResponseType, BodyType, ParamType>(
  url: string,
  body?: BodyType,
  queryParams?: ParamType,
) =>
  axiosInstance.put<ResponseType>(url, body, {
    ...(queryParams && { params: queryParams }),
  });

const deleteAxios = async <ResponseType, BodyType, ParamType>(
  url: string,
  body?: BodyType,
  queryParams?: ParamType,
) =>
  axiosInstance.delete<ResponseType>(url, {
    ...(body && { data: body }),
    ...(queryParams && { params: queryParams }),
  });

//================medical========================
export const fetchMedicalHome = async (payload: IMedicalHomePayload) => {
  const res = await postAxios<IMedicalHomeResponse, IMedicalHomePayload, null>(
    `${ADMIN_SERVER}/admin/receipt/home`,
    payload,
  );
  return res.data;
};
//여권조회
export const medicalPassportValidate = async (passportNumber: string) => {
  const res = await getAxios(`${ADMIN_SERVER}/admin/receipt/${passportNumber}`);
  return res.data as IMedicalPassportValidateRespones;
};
//검증 메일 전송
export const sendMedicalVerificationMail = async (
  payload: ISendVerificationMailPayload,
) => {
  const res = await postAxios<number, ISendVerificationMailPayload, null>(
    `${ADMIN_SERVER}/mail/receipt`,
    payload,
  );
  return res.status;
};
//검증된 이메일 저장
export const verifyMedicalEmail = async (payload: IVerifyEmailPayload) => {
  const res = await patchAxios<number, IVerifyEmailPayload, null>(
    `${ADMIN_SERVER}/admin/receipt/mail`,
    payload,
  );
  return res.status;
};
//검증된 이메일 조회
export const getMedicalVerifiedEmail = async (
  payload: IGetVerifiedEmailPayload,
) => {
  const res = await postAxios<number, IGetVerifiedEmailPayload, null>(
    `${ADMIN_SERVER}/admin/receipt/mail`,
    payload,
  );
  return res.status;
};
//환급 내역 조회
export const getMedicalRefundList = async (passportNumber: string) => {
  const res = await postAxios(`${ADMIN_SERVER}/admin/receipt`, {
    passportNumber,
  });
  return res.data as IGetMedicalRefundListResponse;
};
// 메디컬 계좌 정보 등록
export const registerMedicalRefundInfo = async ({
  isForTemporaryStorage,
  ...payload
}: IRegisterRefundInfoPayload) => {
  await postAxios<
    IRegisterRefundInfoResponse,
    IRegisterRefundInfoPayload,
    null
  >(`${ADMIN_SERVER}/admin/receipt/account`, payload);
  return { isForTemporaryStorage: isForTemporaryStorage };
};
// 메디컬 송금정보 불러오기
export const getMedicalRefundInfo = async (passportNumber: string | null) => {
  const res = await getAxios<any, string>(
    `${ADMIN_SERVER}/admin/receipt/account/${passportNumber}`,
  );
  return res.data;
};
//엑셀 데이터 조회
export const fetchExcelData = async (payload: IExcelBody) => {
  const res = await postAxios<IExcelResponse, IExcelBody, null>(
    `${ADMIN_SERVER}/admin/excel`,
    payload,
  );
  return getFormattedTableData(res.data);
};
//의료용역공급확인서 이미지 변환 후 서버에 저장
export const uploadExel = async (payload: IUploadExcelImagePayload) => {
  const res = await postAxios<string, FormData, null>(
    `${ADMIN_SERVER}/admin/refund/upload`,
    payload.formData,
  );
  return res.data;
};

// 전액결제 출국날짜 이메일 입력
export const updateMedicalDepartureInfo = async (
  payload: IMedicalDepartureInfoPayload,
) => {
  const res = await postAxios<string, IMedicalDepartureInfoPayload, null>(
    `${ADMIN_SERVER}/admin/receipt/departure`,
    payload,
  );
  return res.data;
};
//이메일 인증여부 확인
export const checkEmailAuth = async (payload: CheckEmailPayload) => {
  const res = await postAxios<any, any, null>(
    `${ADMIN_SERVER}/admin/receipt/mail-check`,
    payload,
  );
  return res.data;
};
// 리플렛 고객 송금 정보 입력
export const getRefundInfoData = async (payload: FormData) => {
  const res = await postAxios<string, FormData, null>(
    `${ERP_SERVER}/customer/fault/leaflet`,
    payload,
  );
  return res.data;
};
// 나의 문의 내역 조회
export const getMyQnaList = async (passportNumber: string) => {
  const res = await getAxios(`${ADMIN_SERVER}/question/${passportNumber}`);
  return res.data as IMyQna[];
};
// 문의하기
export const sendMedicalInquiry = async (payload: FormData) => {
  const res = await postAxios(`${ADMIN_SERVER}/question`, payload);
  return res.status;
};
// 문의 답변 읽음처리
export const updateNewAnswer = async (passportNumber: string) => {
  const res = await patchAxios(`${ADMIN_SERVER}/question/${passportNumber}`);
  return res.data;
};
// 한국인 출국확인 필요여부 조회
export const checkKorDeparture = async (passportNumber: string) => {
  const res = await postAxios(
    `${ADMIN_SERVER}/admin/receipt/check-kor-departure`,
    { passportNumber },
  );
  return res.data as ICheckKorDepartureRespones;
};
// 한국인 출국여부 업데이트
export const updateKorDeparture = async (payload: IUpdateKorDeparture) => {
  const res = await postAxios(
    `${ADMIN_SERVER}/admin/receipt/kor-departure`,
    payload,
  );
  return res.data;
};

// 한국인 티켓 업로드
export const uploadTicket = async (payload: FormData) => {
  const res = await postAxios(`${ADMIN_SERVER}/admin/receipt/ticket`, payload);
  return res.data;
};

// 한국인 계좌 인증
export const verifyKoreanAccount = async (payload: VerifyAccountPayload) => {
  const res = await postAxios(
    `${ADMIN_SERVER}/admin/receipt/validate-account`,
    payload,
  );
  return res.data as VerifyAccountResponse;
};

// 공항 전표 리스트 조회
export const getAirportList = async (payload: AirportListPayload) => {
  const res = await postAxios(`${ADMIN_SERVER}/admin/receipt/airport`, payload);
  return res.data as AirportListResponse;
};

export const getAccountInfo = async (passportNumber: string) => {
  const res = await getAxios(
    `${ADMIN_SERVER}/admin/receipt/accountinfo/${passportNumber}`,
  );
  return res.data;
};

// 로그 추가
export const sendLogToOpenObserve = async ({
  body,
  category,
  trace_id,
  dataForLog,
}: OpenObserveRequest) => {
  const payload = {
    ...(dataForLog && typeof dataForLog === 'object' ? dataForLog : {}),
    timestamp: new Date().toISOString(),
    service_name: category,
    projectVersion: '7.0.11',
    body,
    trace_id,
    level: 'INFO',
  };

  const response = await axios.post(
    'https://log.ktaxpay.com/api/default/default/_json',
    [payload],
    {
      headers: {
        Authorization: 'Basic bGp5QGt0YXhwYXkuY29tOmRsd2xzZHVkMkBCQQ==', // base64 인코딩된 아이디:비번 TODO: env로 분리
        'Content-Type': 'application/json',
      },
    },
  );

  return response.data;
};
export const patchQnaEmail = async (payload: ISendReceiptEmailPayload) => {
  const res = await patchAxios(
    `${ADMIN_SERVER}/admin/receipt/question/email`,
    payload,
  );
  return res.data;
};
